/*
 / Products/services pages
 /
 */

import $, { ready } from "jquery";
import axios from "axios";

import { SearchProduct } from "../utils/_SearchProducts.js";

$(".products-filters__filter-item select").change(function () {
  let query = "?";
  if ($(this).data("filtro") == "linea") {
    query += "linea=" + $(this).val();
  } else {
    $(".products-filters__filter-item select").each(function () {
      let filtro = $(this).data("filtro");
      let valor = $(this).val();
      if (valor && valor !== "0") {
        let filter_string = filtro + "=" + valor + "&";
        query = query + filter_string;
      }
    });
  }
  // console.log(query)
  window.location.href = query == "?linea=0" ? location.pathname : query;
});

$(document).ready(function () {
  // $('.products-grid__counter').text( $('.products-grid .product-card__container:visible').length )
  if (document.querySelector(".products-grid__counter")) {
    $(".products-grid__counter").text(contProduct);
  }
});

$(".products-filters__filter-item input").keyup(function (event) {
  event.preventDefault();

  let serach = new SearchProduct();
  let url = "";
  let log_name = $(this).val();
  let timer;

  if (log_name.length < 2 && serach.isvalid_key(event.which)) {
    $(".products-grid").addClass("products-grid--searching");
    $(".products-grid .productos__search");
    $(".products-grid").removeClass("products-grid--searching");
    $(".products-grid .productos__search").html("").hide();
    $(".products-grid .product-card__container").show();
    $(".products-grid .pagiProduct").show();
    $(".products-grid__counter").text(contProduct);
  }

  if (log_name.length >= 3 && serach.isvalid_key(event.which)) {
    $(".products-grid").addClass("products-grid--searching");
    $(".products-grid .product-card__container").show();

    let linea = $(
      '.products-filters__filter-item select[data-filtro|="linea"]'
    ).val();
    let categories = $(
      '.products-filters__filter-item select[data-filtro|="categoria"]'
    ).val();

    url = `/api/products/${
      categories != null ? categories : linea
    }/${12}/productosSearch.json?query=${log_name}`;

    if (linea == 0 && categories == null) {
      url = `/api/products/${12}/productosSearch.json?query=${log_name}`;
    }

    axios(url)
      .then((res) => {
        let resq = serach.create_product(res.data.data);
        $(".productos__search").html(resq);
        $(".products-grid__counter").text(res.data.data.length);
        $(".products-grid .product-card__container").hide();
        $(".products-grid .pagiProduct").hide();
        $(".products-grid .productos__search").show(1000, function () {
          $(".products-grid").removeClass("products-grid--searching");
        });
      })
      .catch((e) => {
        alert("Ocurrio un error inesperado.");
        console.error(`Ocurrio un error inesperado en: ${e}`);
      });
  }
  // let valor = $(this).val()
  // let query = valor.toLowerCase().replace(/\s+/g, '-');

  // $('.products-grid').addClass('products-grid--searching');
  // $('.products-grid .product-card__container').show();

  // setTimeout(function(){
  // 	$('.products-grid .product-card__container').show();

  // 	$('.products-grid .product-card__container').each(function(){
  // 		let title = $(this).find('h3').text().toLowerCase().replace(/\s+/g, '-')
  // 		if( title.indexOf(query) < 0 ){
  // 			$(this).hide()
  // 		}
  // 	});

  // 	$('.products-grid__counter').text( $('.products-grid .product-card__container:visible').length );
  // 	$('.products-grid').removeClass('products-grid--searching');

  // }, 1100);
});

/*let urlSearch = new URL(window.location.href);*/
/*if (urlSearch.searchParams.get("search")) {*/
/*(function () {*/
/*try {*/
/*let log_name = urlSearch.searchParams.get("search");*/
/*let serach = new SearchProduct();*/
/*document.querySelector(".products-filters input").value = log_name;*/
/*let linea = $(*/
/*'.products-filters__filter-item select[data-filtro|="linea"]'*/
/*).val();*/
/*let categories = $(*/
/*'.products-filters__filter-item select[data-filtro|="categoria"]'*/
/*).val();*/

/*let url = `/api/products/${*/
/*categories != null ? categories : linea*/
/*}/${12}/productosSearch.json?query=${log_name}`;*/

/*if (linea == 0 && categories == null) {*/
/*url = `/api/products/${12}/productosSearch.json?query=${log_name}`;*/
/*}*/

/*axios(url)*/
/*.then((res) => {*/
/*let resq = serach.create_product(res.data.data);*/
/*$(".productos__search").html(resq);*/
/*$(".products-grid__counter").text(res.data.data.length);*/
/*$(".products-grid .product-card__container").hide();*/
/*$(".products-grid .pagiProduct").hide();*/
/*$(".products-grid .productos__search").show(1000, function () {*/
/*$(".products-grid").removeClass("products-grid--searching");*/
/*});*/
/*})*/
/*.catch((e) => {*/
/*alert("Ocurrio un error inesperado.");*/
/*console.error(`Ocurrio un error inesperado en: ${e}`);*/
/*});*/
/*} catch (Exception) {*/
/*console.warn("Exception in search => " + Exception);*/
/*}*/
/*})();*/
/*}*/

